import { useState, useCallback } from 'react'

interface ToastData {
  id: string
  title?: string
  description?: string
  variant?: 'default' | 'destructive'
}

export function useToast() {
  const [toasts, setToasts] = useState<ToastData[]>([])

  const toast = useCallback(
    ({ title, description, variant = 'default' }: Omit<ToastData, 'id'>) => {
      const id = Math.random().toString(36).substring(2, 9)
      const newToast: ToastData = { id, title, description, variant }
      
      setToasts((prev) => [...prev, newToast])

      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id))
      }, 5000)
    },
    []
  )

  const dismiss = useCallback((id: string) => {
    setToasts((prev) => prev.filter((t) => t.id !== id))
  }, [])

  return { toasts, toast, dismiss }
}